import { useWorkflows } from '@/store/workflows';

export function AddWorkflowButton() {
  const addWorkflow = useWorkflows((s) => s.addWorkflow);
  return (
    <button
      onClick={() => addWorkflow()}
      className="group inline-flex items-center gap-2 rounded-full border border-ink-800 bg-ink-900 hover:bg-ink-850 px-3.5 py-1.5 text-xs text-ink-300 transition-colors"
      aria-label="new workflow"
    >
      <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-ink-800 text-ink-200 group-hover:bg-accent-500 group-hover:text-ink-950 transition-colors">+</span>
      <span>new stream</span>
    </button>
  );
}
